import React, { useEffect, useState } from "react";

//import Breadcrumbs
import { Loading } from "../../components/common/Loading";

import { Button, Col, Container, Row } from "reactstrap";

import { Form, Formik } from "formik";
import { XCheckbox } from "../../components/common/inputs/XCheckbox";
import { XFileInput } from "../../components/common/inputs/XFileInput";
import { XSelect } from "../../components/common/inputs/XSelect";
import { XTextBox } from "../../components/common/inputs/XTextBox";

const FinanceUpload = (props: any) => {

  const terms = [
    { value: 'I', text: 'I' },
    { value: 'II', text: 'II' },
    { value: 'III', text: 'III' }
  ]

  const { message = "" } = props;

  return (
    <React.Fragment>
      <div>
        <Container fluid>
          <Formik
            initialValues={props.initialValues}
            enableReinitialize
            validateOnBlur
            onSubmit={(values: any) => props.handleSubmit(values)}
          >
            {({ isSubmitting, setFieldValue, values, errors, touched }) => (
              <>
                {message.length > 0 &&
                  <div className="succes">{message}</div>
                }
                <Form>
                  <Row>
                    <Col lg={6}>
                      <XFileInput
                        key="file"
                        id="file"
                        name={"file"}
                        label={"Upload Excel File"}
                        onChange={
                          (event: any) => {
                            setFieldValue('file', event.currentTarget.files[0]);
                          }
                        }
                        errors={errors}
                      />
                    </Col>
                    <Col lg={3}>
                      <XSelect
                        key="term"
                        id="term"
                        name={"term"}
                        options={terms}
                        label={"Term"}
                        touched={touched}
                        errors={errors}
                      />
                    </Col>
                    <Col lg={3}>
                      <XTextBox
                        type="text"
                        key="year"
                        id="year"
                        name={"year"}
                        label={"Year"}
                        touched={touched}
                        errors={errors}
                      />
                    </Col>
                  </Row>
                  <Row>
                  <Col lg={3}>
                      <XTextBox
                        type="number"
                        key="balance_prepaid"
                        id="balance_prepaid"
                        name={"balance_prepaid"}
                        label={"Prepaid Position"}
                        touched={touched}
                        errors={errors}
                      />
                    </Col>
                    <Col lg={3}>
                      <XTextBox
                        type="number"
                        key="balance_bf"
                        id="balance_bf"
                        name={"balance_bf"}
                        label={"Bal. B/F Position"}
                        touched={touched}
                        errors={errors}
                      />
                    </Col>
                    <Col lg={3}>
                      <XTextBox
                        type="text"
                        key="memo"
                        id="memo"
                        name={"memo"}
                        label={"Cr. Memo Positions"}
                        touched={touched}
                        errors={errors}
                      />
                    </Col>                    
                    <Col lg={3}>
                      <XTextBox
                        type="number"
                        key="invoice"
                        id="invoice"
                        name={"invoice"}
                        label={"Inv. Position"}
                        touched={touched}
                        errors={errors}
                      />
                    </Col>
                  </Row>
                  <Row>
                  <Col lg={3}>
                      <XTextBox
                        type="number"
                        key="receipt"
                        id="receipt"
                        name={"receipt"}
                        label={"Payment Position"}
                        touched={touched}
                        errors={errors}
                      />
                    </Col>
                    <Col lg={2}>
                      <div>&nbsp;</div>
                      <Button
                        disabled={false}
                        type="submit"
                        className="btn btn-primary"
                      >
                        Upload
                      </Button>
                    </Col>
                  </Row>
                </Form>
                <hr />
              </>
            )}
          </Formik>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default FinanceUpload;
